/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import IconButton from '@material-ui/core/IconButton';
import Swal from 'sweetalert2';
import validaNumber from '../../../tools/validaNumber';
import validaString from '../../../tools/validaString';
import mascaraCampoDecimal from '../../../tools/mascaras/campoDecimal';
import somenteDecimal from '../../../tools/somenteDecimal';
import apresentarDecimal from '../../../tools/apresentarDecimal';
import Grid from '@material-ui/core/Grid';
import api from '../../../services/api';
import Typography from '@material-ui/core/Typography';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';

const useStyles = makeStyles(theme => ({
    controlaTitulo: {
        fontSize: "1.5em",
    },
    textField: {
        marginBottom: 8,
    },
    botaoRodape: {
        padding: theme.spacing(1),
    },
    controlaAddVolume: {
        margin: "0px 0px 5px 0px"
    }
}))

export default function FormVolumeNfe(props) {

    const { adicionarVolume, removerVolume, volumeNfe, grid, indexVolume, inativo } = props;

    const classes = useStyles();

    const [codigoVolume, setCodigoVolume] = useState(volumeNfe ? volumeNfe.codigoVolume : 0);

    const [quantidade, setQuantidade] = useState(volumeNfe ? volumeNfe.quantidade : '');
    const [quantidadeErro] = useState(false);
    const [quantidadeErroTexto] = useState();

    const [pesoBruto, setPesoBruto] = useState(volumeNfe ? apresentarDecimal(volumeNfe.pesoBruto) : '');
    const [pesoBrutoErro] = useState(false);
    const [pesoBrutoErroTexto] = useState();

    const [pesoLiquido, setPesoLiquido] = useState(volumeNfe ? apresentarDecimal(volumeNfe.pesoLiquido) : '');
    const [pesoLiquidoErro] = useState(false);
    const [pesoLiquidoErroTexto] = useState();

    const [numeracao, setNumeracao] = useState(volumeNfe ? volumeNfe.numeracao : '');
    const [numeracaoErro] = useState(false);
    const [numeracaoErroTexto] = useState();

    const [especie, setEspecie] = useState(volumeNfe ? volumeNfe.especie : '');
    const [especieErro] = useState(false);
    const [especieErroTexto] = useState();

    const [marca, setMarca] = useState(volumeNfe ? volumeNfe.marca : '');
    const [marcaErro] = useState(false);
    const [marcaErroTexto] = useState();

    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        if (volumeNfe) {
            return
        }
        if (open) {
            setCodigoVolume(0);
            setQuantidade('');
            setPesoBruto('');
            setPesoLiquido('');
            setNumeracao('');
            setEspecie('');
            setMarca('');
        }
    }, [open])

    function salvar() {
        setOpen(false);
        adicionarVolume(
            {
                codigoVolume,
                quantidade,
                pesoBruto: somenteDecimal(pesoBruto),
                pesoLiquido: somenteDecimal(pesoLiquido),
                numeracao,
                especie,
                marca,
            }, indexVolume);

        const Toast = Swal.mixin({
            toast: true,
            position: 'top-right',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })

        Toast.fire({
            type: 'success',
            title: 'Volume Salvo'
        })
    }

    function cancelar() {
        setOpen(false);
    }

    function apresentarDeletar() {
        if (volumeNfe && !inativo) {
            return <Grid item xs={6} className={classes.botaoRodape}>
                <Button
                    variant="contained"
                    color="secondary"
                    type="button"
                    onClick={deletar}
                    fullWidth
                >
                    Deletar
                </Button>
            </Grid>
        }
    }

    async function deletar() {
        if (codigoVolume) {

            let dadosEnvio = {
                DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
                DBUSERNAME: localStorage.getItem("DBUSERNAME"),
                DBESQUEMA: localStorage.getItem("DBESQUEMA"),
                DBPID: localStorage.getItem("DBPID"),
                MANDNUMBER: localStorage.getItem("MANDNUMBER"),
                PROCNAME: "WEBSITE_NFVOLUMES_DELETE",
                EMPNUMBER: localStorage.getItem("EMPNUMBER"),
                PCNRVOL: codigoVolume
            };

            const resposta = await api.post('/execute', dadosEnvio);

            if (resposta.data.CODIGO_ERRO == 0) {
                setOpen(false);
                removerVolume(indexVolume);
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-right',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    onOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    type: 'success',
                    title: 'Item Removido'
                })
            }
        } else {
            setOpen(false);
            removerVolume(indexVolume);
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                type: 'success',
                title: 'Item Removido'
            })
        }

    }

    const handleOpen = (e) => {
        e.preventDefault();
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            {grid ? <IconButton aria-label="alterar"
                onClick={handleOpen}
            >
                {inativo ? <VisibilityIcon /> : <EditRoundedIcon />}
            </IconButton> : <Button
                type="button"
                variant="contained"
                color="secondary"
                fullWidth
                className={classes.controlaAddVolume}
                startIcon={<AddCircleOutlineOutlinedIcon />}
                onClick={handleOpen}
                disabled={inativo}
            >
                Adicionar Volume
            </Button>}
            <Dialog
                open={open}
                onClose={handleClose}
                scroll='paper'
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullScreen
            >
                <DialogTitle id="scroll-dialog-title">
                    <Grid container>
                        <Grid item xs={volumeNfe && !inativo ? 6 : 12} className={classes.botaoRodape}>
                            <Typography
                                variant="h1"
                                component="h1"
                                gutterBottom
                                align="center"
                                color="primary"
                                className={classes.controlaTitulo}
                            >
                                Volumes
            </Typography>
                        </Grid>

                        {apresentarDeletar()}

                    </Grid>
                </DialogTitle>
                <DialogContent dividers='true'>
                    <DialogContentText
                        id="scroll-dialog-description"

                        tabIndex={-1}
                    >

                        <form>
                            <TextField
                                className={classes.textField}
                                label="Quantidade"
                                error={quantidadeErro}
                                fullWidth
                                helperText={quantidadeErroTexto}
                                variant="outlined"
                                value={quantidade}
                                onChange={e => validaNumber(setQuantidade, 8, e.target.value)}
                                disabled={inativo}
                            />

                            <TextField
                                className={classes.textField}
                                label="Peso Bruto"
                                error={pesoBrutoErro}
                                fullWidth
                                helperText={pesoBrutoErroTexto}
                                variant="outlined"
                                value={pesoBruto}
                                onChange={e => setPesoBruto(e.target.value)}
                                disabled={inativo}
                                InputProps={{
                                    inputComponent: mascaraCampoDecimal,
                                }}
                            />

                            <TextField
                                className={classes.textField}
                                label="Peso Liquido"
                                error={pesoLiquidoErro}
                                fullWidth
                                helperText={pesoLiquidoErroTexto}
                                variant="outlined"
                                value={pesoLiquido}
                                onChange={e => setPesoLiquido(e.target.value)}
                                disabled={inativo}
                                InputProps={{
                                    inputComponent: mascaraCampoDecimal,
                                }}
                            />

                            <TextField
                                className={classes.textField}
                                label="Numeração"
                                error={numeracaoErro}
                                fullWidth
                                helperText={numeracaoErroTexto}
                                variant="outlined"
                                value={numeracao}
                                disabled={inativo}
                                onChange={e => validaNumber(setNumeracao, 30, e.target.value)}
                            />

                            <TextField
                                className={classes.textField}
                                label="Espécie"
                                error={especieErro}
                                fullWidth
                                helperText={especieErroTexto}
                                variant="outlined"
                                value={especie}
                                onChange={e => validaString(setEspecie, 30, e.target.value)}
                                disabled={inativo}
                            />

                            <TextField
                                className={classes.textField}
                                label="Marca"
                                error={marcaErro}
                                fullWidth
                                helperText={marcaErroTexto}
                                variant="outlined"
                                value={marca}
                                onChange={e => validaString(setMarca, 30, e.target.value)}
                                disabled={inativo}
                            />

                        </form>

                    </DialogContentText>


                </DialogContent>
                <DialogActions>
                    <Grid container>
                        {inativo ? <Grid item xs={12} className={classes.botaoRodape}>
                            <Button
                                variant="contained"
                                color="secondary"
                                type="button"
                                onClick={cancelar}
                                fullWidth
                            >
                                Sair
                                </Button>
                        </Grid> : <>
                            <Grid item xs={6} className={classes.botaoRodape}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    type="button"
                                    onClick={cancelar}
                                    fullWidth
                                >
                                    Cancelar
                            </Button>
                            </Grid>
                            <Grid item xs={6} className={classes.botaoRodape}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={salvar}
                                    fullWidth
                                >
                                    Salvar
                            </Button>
                            </Grid>
                        </>}
                    </Grid>
                </DialogActions>
            </Dialog>


        </div>
    )
}